var Props = function Props() {
  var maybeProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = {};
  Object.keys(maybeProps).forEach(function (propName) {
    if (maybeProps[propName]) {
      props[propName] = maybeProps[propName];
    }
  });
  return props;
};
var Props$1 = Props;

export { Props$1 as default };
//# sourceMappingURL=props.js.map
